export const nowInMillseconds = () => Date.now();

export const deltaInMilliseconds = (ts1: number, ts2: number) => ts1 - ts2;

export const deltaInSeconds = (ts1: number, ts2: number): number => (ts1 - ts2) / 1000;


// WEBPACK FOOTER //
// ./src/Utils/TimeUtil.js